import { useEffect } from "react";
import IconValidationCheck from "@/app/(components)/generics/Icons/IconValidationCheck";
import styles from "./SuccessMessage.module.css";

type Props = {
  message: string;
  onHide?: () => void;
  delay?: number;
};

export default function SuccessMessage({ message, onHide, delay = 1500 }: Props) {
  useEffect(() => {
    if (!onHide) return;
    const timer = setTimeout(onHide, delay);
    return () => clearTimeout(timer);
  }, [onHide, delay]);

  return (
    <p className={styles.successMessage}>
      <IconValidationCheck />
      <span>{message}</span>
    </p>
  );
}
